import { render, staticRenderFns } from "./AddSubjectLabelDialog.vue?vue&type=template&id=63aef476&scoped=true&"
import script from "@/views/SubjectLabels/AddSubjectLabelDialog.ts?vue&type=script&lang=ts&"
export * from "@/views/SubjectLabels/AddSubjectLabelDialog.ts?vue&type=script&lang=ts&"
import style0 from "@/views/SubjectLabels/add-subject-label-dialog.scss?vue&type=style&index=0&id=63aef476&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63aef476",
  null
  
)

export default component.exports